import { getMetaTagValue } from '../getMetaTagValue';

export function getToken() {
  const key = getMetaTagValue('csrf-param');
  const value = getMetaTagValue('csrf-token');
  return { [key]: value };
}
